/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:50:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Root/index.tsx
 */
import React from 'react';
import { useDispatch } from 'react-redux';

import HOC from '../HOC';
// import {
//   getContent,
//   getCollapse,
//   onCollapseChange,
//   getLoaded,
//   getMoveList,
// } from '../slice';
// import Table from '../Table';
// import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Top from 'src/pages/SalesChannelCategory/Components/Card';
import { useI18n } from 'src/hooks/useRouterChange';
import RootModal from 'src/pages/SalesChannelCategory/Components/EditModal/Root';
import Header from 'src/pages/SalesChannelCategory/Components/Header';
import WrapperRoot from 'src/pages/SalesChannelCategory/Components/RootWrapper';
import Card from 'src/pages/SalesChannelCategory/ProductCategory/Card';
import { submitChange } from 'src/pages/SalesChannelCategory/ProductCategory/EditModal/tools';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { onDataUpdate } from '../slice';
const Root = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const {
    data,
    moveList,
    salesChannelUuid,
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    userPermissions,
  } = props;
  //console.log(salesChannelUuid);
  const { uuid, salesChannelItems = [], name, urlSlug } = data || {};

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    onModalCancel();
  };

  //====request

  const submissionId = `postCategoryProduct${salesChannelUuid}`;
  const requestId = [submissionId];

  const _submitChange = ({ urlSlug, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: submissionId,
      urlSlug,
      name,
      onOk: handleOnDataUpdate,
      parentUuid: null,
    });
  };
  //===request

  const onEdit = () => {
    setModalTitle(getI18n('salesChannelCategoryProducts.index.editCategory'));
    setModalContent(
      <RootModal
        requestId={requestId}
        onSubmit={_submitChange}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        name={name}
        urlSlug={urlSlug}
        uuid={uuid}
        slugCheckingUrl={'portal/salesChannel/category/products/checkUrlSlug'}
      />,
    );
    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card
        name={name}
        slug={urlSlug}
        uuid={`root${uuid}`}
        products={salesChannelItems}
        moveList={moveList}
        salesChannelUuid={salesChannelUuid}
        isRoot
        userPermissions={userPermissions}
        onEdit={onEdit}
      />
    </React.Fragment>
  );
};

export { Root };

const rootNameI18nMapping = {
  // 应该还有别的,遇到再加
  Products: 'general.sider.products',
};

export default WrapperRoot(
  HOC(Root, {
    titleGenerator: (data) => {
      const { name, fullUrl, numOfItems } = data;
      return (
        <Header
          title={getI18nFromGeneral(rootNameI18nMapping[name])}
          productsAmount={numOfItems}
          url={fullUrl}
          subTitle={getI18nFromGeneral(
            'general.hOCTitle.productCategoryRootSubTitle',
          )}
        />
      );
    },
  }),
);
